import { formatDistance, parseISO } from 'date-fns';

import { SortFunction } from 'context/LoadableItems/types/LoadableItems';
import { Status } from 'features/Frames/types';

export const statusMessageWriter = (status: Status | null): String => {
  if (status == null) {
    return 'No status found';
  }
  return `${getTimeSince(status.time)} ago`;
};

export const sortStatuses: SortFunction<Status> = (a, b) =>
  new Date(b.time).getTime() - new Date(a.time).getTime();

const getTimeSince = (time: string): string => {
  return formatDistance(parseISO(time), new Date());
};
